/**
 * Client-side condition evaluation (same semantics as backend evaluate_condition).
 */

function toFloat(val, defaultValue = 0) {
  if (val === null || val === undefined) return defaultValue
  const n = typeof val === 'number' ? val : parseFloat(String(val).trim())
  return Number.isFinite(n) ? n : defaultValue
}

function evaluateLeaf(cond, params) {
  const paramName = cond.param
  const op = cond.op
  const target = cond.value !== undefined ? cond.value : 0
  let actual = params[paramName]
  if (typeof actual === 'string' || typeof target === 'string') {
    const actualStr = actual != null ? String(actual) : ''
    const targetStr = target != null ? String(target) : ''
    if (op === 'eq') return actualStr === targetStr
    if (op === 'neq') return actualStr !== targetStr
    return false
  }
  actual = toFloat(actual)
  const t = toFloat(target)
  const ops = {
    eq: (a, b) => a === b,
    neq: (a, b) => a !== b,
    gt: (a, b) => a > b,
    gte: (a, b) => a >= b,
    lt: (a, b) => a < b,
    lte: (a, b) => a <= b,
  }
  const fn = ops[op]
  return fn ? fn(actual, t) : false
}

export function evaluateCondition(condition, params) {
  if (!condition || typeof condition !== 'object') return false
  if ('param' in condition && 'op' in condition) {
    return evaluateLeaf(condition, params || {})
  }
  const logic = (condition.logic || 'and').toLowerCase()
  const sub = condition.conditions || []
  if (!sub.length) return false
  const results = sub.map((c) => evaluateCondition(c, params || {}))
  return logic === 'and' ? results.every(Boolean) : results.some(Boolean)
}
